import {
  AutocompleteField,
  CheckboxField,
  CountryField,
  DatepickerField,
  HiddenField,
  MoneyInputField,
  PhoneInputField,
  TextInputField,
} from 'components/FieldList/Field';
import { MultipleCheckboxField } from 'components/FieldList/Field/MultipleCheckboxField/MultipleCheckboxField';
import { RadioField } from 'components/FieldList/Field/RadioField/RadioField';
import PropTypes from 'prop-types';
import { logger } from 'services/logger/logger';

const Nothing = () => null;
export const Field = ({ field, onChange, onBlur }) => {
  let Wrapper;

  if (!field.type && !field.value) {
    return <Nothing />;
  }

  if (field.hidden) {
    Wrapper = HiddenField;
  } else if (field.type === 'boolean') {
    Wrapper = CheckboxField;
  } else if (field.type === 'string' && Array.isArray(field.value)) {
    if (field.format === 'country') {
      Wrapper = CountryField;
    } else {
      Wrapper = AutocompleteField;
    }
  } else if (field.type === 'array' && Array.isArray(field.value)) {
    Wrapper = MultipleCheckboxField;
  } else if (field.type === 'enum') {
    Wrapper = RadioField;
  } else if (field.type === 'string' && field.format === 'money') {
    logger.log({
      description: 'Checkout: Field with type string and format money',
      parameters: field,
    });
    Wrapper = MoneyInputField;
  } else if (field.type === 'string' && field.format === 'date') {
    Wrapper = DatepickerField;
  } else if (field.type === 'string' && field.format === 'phone') {
    Wrapper = PhoneInputField;
  } else {
    Wrapper = TextInputField;
  }

  return <Wrapper field={field} handleChange={onChange} handleBlur={onBlur} />;
};

Field.displayName = 'Field';
Field.propTypes = {
  field: PropTypes.object,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
};
